export default "__VITE_ASSET__FmZm3okW__"